import { format } from 'date-fns'

import { useDateStore } from '@/components/DateInput'
import { DisruptionsTable } from './components/DisruptionsTable'
import { useReaderLogStore } from '@/modules/FindControllerLog/store'

import styles from './Disruptions.module.scss'

export const ReaderDisruptions = () => {
    const { source } = useReaderLogStore()
    const { date } = useDateStore()

    return (
        <section className={styles.root}>
            <header className={styles.header}>
                <div className={styles.details}>
                    <h1 className={styles.title}>{source?.title} disruptions</h1>
                    <p className={styles.date}>{format(date, 'cccc d MMMM')}</p>
                </div>
            </header>
            <div className={styles.container}>
                <DisruptionsTable />
            </div>
        </section>
    )
}
